const headers = {
  name: "Inventory batch",
  navigate: {
    tabs: [
      {
        name: "Batch",
        path: "/app/inventory",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
